import { parsePath } from "history";
import { getBasePath } from "../getBasePath.js";
import { _internalApiMatchStoryboard } from "./Runtime.js";
import { isOutsideApp } from "./matchStoryboard.js";
let blocked = false;
export function getUserConfirmation(message, callback) {
  blocked = !confirm(message);
  callback(!blocked);
}
export function historyExtended(browserHistory) {
  const {
    push: originalPush,
    replace: originalReplace
  } = browserHistory;
  function push(location, state, callback) {
    blocked = false;
    originalPush(location, state);
    callback === null || callback === void 0 || callback(blocked);
  }
  function replace(location, state, callback) {
    blocked = false;
    originalReplace(location, state);
    callback === null || callback === void 0 || callback(blocked);
  }
  function updateQueryFactory(method) {
    return function updateQuery(query) {
      let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      let callback = arguments.length > 2 ? arguments[2] : undefined;
      const {
        extraQuery,
        clear,
        keepHash,
        ...state
      } = options;
      const urlSearchParams = new URLSearchParams(clear ? "" : browserHistory.location.search);
      const params = {};
      Object.assign(params, query, extraQuery);
      for (const [key, value] of Object.entries(params)) {
        if (Array.isArray(value)) {
          urlSearchParams.delete(key);
          for (const item of value) {
            urlSearchParams.append(key, item);
          }
        } else if (value === undefined || value === null || value === "") {
          urlSearchParams.delete(key);
        } else {
          urlSearchParams.set(key, value);
        }
      }
      (method === "push" ? push : replace)(`?${urlSearchParams.toString()}${keepHash ? browserHistory.location.hash : ""}`, state, callback);
    };
  }
  function pushAnchor(hash, state, callback) {
    push({
      ...browserHistory.location,
      key: undefined,
      hash,
      state: {
        // The default notify is false
        notify: false,
        ...state
      }
    }, undefined, callback);
  }
  function reload(callback) {
    replace({
      ...browserHistory.location,
      state: {
        ...browserHistory.location.state,
        // Always notify
        notify: true,
        // Do not use incremental sub routes
        noIncremental: true
      }
    }, undefined, callback);
  }
  let blockMessage;
  function setBlockMessage(message) {
    blockMessage = message;
  }
  function getBlockMessage() {
    return blockMessage;
  }
  function unblock() {
    blockMessage = undefined;
  }
  return {
    pushQuery: updateQueryFactory("push"),
    replaceQuery: updateQueryFactory("replace"),
    pushAnchor: pushAnchor,
    reload,
    setBlockMessage,
    getBlockMessage,
    unblock,
    ...historyOverridden({
      ...browserHistory,
      push,
      replace
    })
  };
}

/**
 * Override history for standalone micro apps.
 *
 * when `push` or `replace` to other apps, force page refresh.
 */
function historyOverridden(browserHistory) {
  const {
    push: originalPush,
    replace: originalReplace
  } = browserHistory;
  function updateFactory(method) {
    return function update(path, state, callback) {
      let pathname;
      const pathIsString = typeof path === "string";
      if (pathIsString) {
        pathname = parsePath(path).pathname;
      } else {
        pathname = path.pathname;
      }

      // When history.push or history.replace is performing with an absolute pathname,
      // force load the target page when it is a page of an outside app.
      if (typeof pathname === "string" && pathname.startsWith("/") && isOutsideApp(_internalApiMatchStoryboard(pathname))) {
        // Going to outside apps.
        return location[method === "push" ? "assign" : "replace"](pathIsString ? getBasePath() + path.substring(1) : browserHistory.createHref(path));
      }
      return (method === "push" ? originalPush : originalReplace)(path, state, callback);
    };
  }
  return {
    push: updateFactory("push"),
    replace: updateFactory("replace")
  };
}

/**
 * 扩展的系统会话对象。
 */

/**
 * 更新指定的 query 参数。
 *
 * @param query - 要更新的 query 参数。
 * @param options - 选项。
 */

/** 更新 query 参数时的选项 */

/**
 * 设置指定的 anchor （URL hash）地址，此方法默认不会触发页面重新渲染。
 * 往浏览器会话历史栈中推入一条新记录。
 *
 * @param hash - Hash 地址。
 * @param state - 会话状态设置。
 */
//# sourceMappingURL=historyExtended.js.map